import { render, staticRenderFns } from "./communicationDashboardParty.vue?vue&type=template&id=cee154bc&scoped=true"
import script from "./communicationDashboardParty.vue?vue&type=script&lang=js"
export * from "./communicationDashboardParty.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardParty.vue?vue&type=style&index=0&id=cee154bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee154bc",
  null
  
)

export default component.exports